<template>
  <div class="wrap-box">
    <div class="wrap-box-left">
      <el-tabs v-model="tabValue" type="card" @tab-click="tabClick">
        <el-tab-pane lazy :label="$t('tabs.information.projectInformation')" name="xm">
          <IndexTabs ref="xm" :hot-word="hotWord" :country="plCountry" url="/front/article/project/list"
                     :form-items="['countries','categories','source']" module='xm' type="project"
                     @search="queryGHotword"></IndexTabs>
        </el-tab-pane>
        <el-tab-pane lazy :label="$t('tabs.information.opportunityInformation')" name="sj">
          <IndexTabs :key="blKey" lazy ref="sj" :hot-word="hotWord" :country="sjCountry"
                     :form-items="['countries','categories','source']" url="/front/article/business/list"
                     goto="pbrBusinessDetail" type="business" module='sj'
                     @search="queryGHotword"></IndexTabs>
        </el-tab-pane>
        <el-tab-pane lazy :label="$t('tabs.information.riskInformation')" name="fx">
          <IndexTabs ref="fx" :hot-word="hotWord" :country="rlCountry" :form-items="['countries','categories','source']"
                     url="/front/article/risk/list" module='fx' type="risk"
                     @search="queryGHotword"></IndexTabs>
        </el-tab-pane>
        <el-tab-pane lazy :label="$t('tabs.information.riskEvent')" name='fxsj'>
          <IndexTabs :key="rKey" ref="fxsj" :hot-word="hotWord" :country="fxsjCountry" :category="fxsjCategory"
                     :form-items="['countries','categories','source']" show-more-height='90px' url="/front/article/risk"
                     goto="pbrRiskDetail" module='fxsj' tag-field="label"
                     @search="queryGHotword"></IndexTabs>
        </el-tab-pane>
        <!-- 英文版暂时不显示多边动态 -->
        <el-tab-pane v-if="!isEn" lazy :label="$t('tabs.information.multilateralDynamics')" name="dbdt">
          <MultilateralDynamics
            ref="dbdt"
            :hot-word="hotWord"
            :region-filter="mdRegionFilter"
            @region-stat="onMdRegionStat"
            @hotspot="onMdHotSpot">
          </MultilateralDynamics>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="wrap-box-right">
      <template v-if="!isEn && tabValue === 'dbdt'">
        <div class="pbr-title">{{ $t('label.information.multilateral.regionOverview') }}</div>
        <RegionOverview :data="mdRegionData" @select="onMdRegionSelect"></RegionOverview>
        <div class="pbr-title">{{ $t('label.information.informationHotspot') }}</div>
        <normal-list :page-size="15" :data="mdHotSpotData" goto="pbrMultilateralDetail"></normal-list>
      </template>
      <template v-else>
        <div class="pbr-title">{{ tabValue === 'fxsj' ? $t('label.information.informationRiskHotWords') : $t('label.information.informationHotWords') }}</div>
        <div style="height: 400px;">
          <hot-word-analysis v-if="hotWordData.length" :word-data="hotWordData" @hotClick="hotClick"></hot-word-analysis>
          <Empty v-else></Empty>
        </div>
        <div class="pbr-title">{{ tabValue === 'fxsj' ? $t('label.information.informationRiskHotspot') : $t('label.information.informationHotspot') }}</div>
        <normal-list :page-size="6" :data="hotSpotData" :goto="tabValue === 'fxsj' ? 'pbrRiskDetail' : 'pbrInfoDetail'"></normal-list>
      </template>
    </div>
  </div>
  <!-- 此文件英文 不需要 -->
  <!-- <noPermiss v-else></noPermiss> -->
</template>

<script>
import IndexTabs from './IndexTabs'
import MultilateralDynamics from './MultilateralDynamics'
import RegionOverview from './RegionOverview'
import NormalList from '../index/NormalList.vue'
import HotWordAnalysis from '../analysis/HotWordAnalysis'
// import noPermiss from '../noPermiss.vue'
export default {
  name: 'pbrInfoIndex',
  components: {IndexTabs, MultilateralDynamics, RegionOverview, HotWordAnalysis, NormalList},
  data () {
    return {
      blKey: (new Date()).getTime(),
      rKey: (new Date()).getTime(),
      tabValue: 'xm',
      plCountry: null,
      sjCountry: null,
      rlCountry: null,
      fxsjCountry: null,
      fxsjCategory: null,
      hotWordData: [],
      hotSpotData: [],
      hotWord: '',
      mdRegionData: [],
      mdHotSpotData: [],
      mdRegionFilter: null
    }
  },
  created () {
    if (this.isEn && (this.tabValue === 'dbdt' || this.$store.state.brpaModule.infoTab === 'dbdt')) {
      this.tabValue = 'xm'
      this.$store.commit('infoTab', 'xm')
    }
    this.queryHotSpot()
  },
  computed:{
    isEn () {
      return localStorage.getItem('locale') === 'en'
    }
  },
  mounted () {

  },
  async activated () {
    let tab = ''

    let tabStore = this.$store.state.brpaModule.infoTab
    if (this.$route.query.key || this.$route.query.tKey) {
      let {key, tabPath} = this.$route.query
      if (!tabPath && !tabStore) {
        tab = 'xm'
      } else {
        tab = tabPath || tabStore
      }
      if (this.isEn && tab === 'dbdt') {
        tab = 'xm'
      }
      this.tabValue = tab
      if (this.$route.query.key) {
        this[tab + 'Country'] = JSON.stringify({id: this.$route.query.key, title: this.$route.query.n})
        if (tab === 'sj') {
          this.blKey = (new Date()).getTime()
        } else if (tab === 'fxsj') {
          this.rKey = (new Date()).getTime()
        }
      }
      if (this.$route.query.tKey) {
        this[tab + 'Category'] = JSON.stringify({id: this.$route.query.tKey, title: this.$route.query.tn})
        this.rKey = (new Date()).getTime()
      }
    }

    if (this.$route.query && Object.keys(this.$route.query).length) {
      let {currentModuleTags, tabPath} = this.$route.query
      if (!tabPath && !tabStore) {
        tab = 'xm'
      } else {
        tab = tabPath || tabStore
      }
      if (this.isEn && tab === 'dbdt') {
        tab = 'xm'
      }
      this.tabValue = tab
      if (tab !== 'dbdt' && this.$refs[tab]) {
        this.$refs[tab].searchForm.countries = await currentModuleTags.filter(c => c.type === 'country').map(c => JSON.stringify({
          id: c.id,
          title: c.title
        }))
        this.$refs[tab].searchForm.categories = await currentModuleTags.filter(c => c.type === 'category').map(c => JSON.stringify({
          id: c.id,
          title: c.title
        }))
        let pdate = await currentModuleTags.filter(c => (c.type === 'signDate' || c.type === 'date')).map(c => {
            let dateArray = []
            dateArray.push(c.start)
            dateArray.push(c.end)
            return dateArray;
        })
        this.$refs[tab].searchForm.pdate = pdate.length > 0 ? pdate[0] : []

        this.$refs[tab].search()
      }
    }
    if (this.$route.params && Object.keys(this.$route.params).length){
       const { currentModuleTags,tabPath } = this.$route.params;
       if(tabPath=='fxsj'){
      this.tabValue='fxsj'
      if(Array.isArray(currentModuleTags)&&currentModuleTags.length>0){
        this.fxsjCountry=JSON.stringify(currentModuleTags[0])
        this.fxsjCategory=JSON.stringify(currentModuleTags[1])
      }

    }
    }
  },
  methods: {
    tabClick (tab) {
      const name = (tab && tab.name) || this.tabValue
      if (name === 'dbdt') {
        this.$nextTick(() => {
          if (this.$refs.dbdt) {
            this.$refs.dbdt.search()
          }
        })
        return
      }
      this.queryGHotword()
      this.queryHotSpot()
    },
    queryGHotword (par) {
      let param = par ? {type:this.tabValue,...par} : {type:this.tabValue}
      this.$pbrApis.queryGHotword(param).then(res => {
        this.hotWordData = res.result
      })
    },
    queryHotSpot () {
      this.$pbrApis.queryHotSpot({type:this.tabValue}).then(res => {
        this.hotSpotData = res.result
      })
    },
    hotClick (hotWord) {
      this.hotWord = hotWord
    },
    onMdRegionStat (data) {
      this.mdRegionData = data || []
    },
    onMdHotSpot (data) {
      this.mdHotSpotData = data || []
    },
    onMdRegionSelect (region) {
      this.mdRegionFilter = Object.assign({}, region, { _t: Date.now() })
    }
  },
  watch: {
    tabValue (n, o) {
      if (n) {
        if (this.isEn && n === 'dbdt') {
          this.tabValue = 'xm'
          return
        }
        this.$store.commit('infoTab', n)
      }
    }
  }

}
</script>
<style scoped>

</style>
